// 投诉建议模块路由
export default [
{
  path: '/approval/allApproval',
  component: resolve => require(['@/pages/approval/allApproval.vue'], resolve),
  name: 'allApproval',
  meta: {
    keepAlive: true,
    title: '所有审批'
  }
},
{
  path: '/approval/postgraduateAllApproval',
  component: resolve => require(['@/pages/approval/allApprovalPostgraduate.vue'], resolve),
  name: 'allApproval',
  meta: {
    keepAlive: true,
    title: '审批统计(研究生)'
  }
},
{
  path: '/approval/todo-approval',
  name: 'todo-approval',
  component: resolve => require(['@/pages/approval/todo-approval.vue'], resolve),
  meta: {
    keepAlive: true,
    title: '审批'
  }
},
{
  path: '/approval/statisticalFigure',
  name: 'approvalStatisticalFigure',
  component: resolve => require(['@/pages/approval/approvalStatisticalFigure.vue'], resolve),
  meta: {
    keepAlive: true,
    title: '审批'
  }
},
{
  path: '/approval/loveTicket',
  name: 'loveTicket',
  component: resolve => require(['@/pages/approval/loveTicket.vue'], resolve),
  meta: {
    keepAlive: true,
    title: '爱心车票补助'
  }
},
{
  path: '/approval/joinArmy',
  name: 'joinArmy',
  component: resolve => require(['@/pages/approval/joinArmy.vue'], resolve),
  meta: {
    keepAlive: true,
    title: '入伍管理'
  }
},
{
  path: '/approval/joinArmyArchives',
  name: 'joinArmyArchives',
  component: resolve => require(['@/pages/approval/joinArmyArchives.vue'], resolve),
  meta: {
    keepAlive: true,
    title: '入伍档案'
  }
},
{
  path: '/approval/lodgingApplication',
  name: 'lodgingApplication',
  component: resolve => require(['@/pages/approval/lodgingApplication.vue'], resolve),
  meta: {
    keepAlive: true,
    title: '校外住宿申请'
  }
},
{
  path: '/approval/dayStudentConfiguration',
  name: 'walkConfiguration',
  component: resolve => require(['@/pages/approval/walkConfiguration.vue'], resolve),
  meta: {
    keepAlive: true,
    title: '校外住宿配置'
  }
},
{
  path: '/winterReturnHome',
  name: 'winterReturnHome',
  component: resolve => require(['@/pages/winterReturnHome/approval.vue'], resolve),
  meta: {
    keepAlive: true,
    title: '寒假离校返乡'
  }
}
]



// WEBPACK FOOTER //
// ./src/router/modules/approval.js